import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, UsersIcon, StarIcon, MapPinIcon, FileTextIcon, ZapIcon, TargetIcon } from 'lucide-react';
export function HeroSection() {
  const handleBuy = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-10 sm:pt-12 sm:pb-16 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-134">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-135" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-center text-center gap-4 sm:gap-6" data-id="element-137">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-navy-800 border border-navy-700 rounded-full px-3 py-1 sm:px-4 sm:py-1.5 w-fit" data-id="element-138">
            <ZapIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gold-400" data-id="element-139" />
            <span className="text-[10px] sm:text-sm font-semibold text-gold-400 uppercase tracking-wider" data-id="element-140">
              3 Tomos + Bonos Estratégicos
            </span>
          </div>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-display leading-[0.9] text-offwhite uppercase" data-id="element-141">
            KIT TENIS DE MESA -{' '}
            <span className="text-gold-500" data-id="element-142">DOMINIO TOTAL</span>
          </h1>

          {/* Mockup Image — between title and subtitle, ~70% size */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative flex justify-center w-full" data-id="element-143">
            <motion.div animate={{
            y: [-5, 5, -5]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} className="relative w-[70%] max-w-[280px] sm:max-w-sm lg:max-w-md" data-id="element-144">
              <div className="absolute inset-0 bg-gold-500 blur-[80px] opacity-20 rounded-full" data-id="element-145" />
              <img src="https://cdn.magicpatterns.com/uploads/ugKZeRA3P9mEGSct8dsvx6/Gemini_Generated_Image_c9w44vc9w44vc9w4.png" alt="Dominio Total - Kit de Tenis de Mesa Pro" width={1024} height={1024} loading="eager" fetchPriority="high" decoding="async" className="relative z-10 w-full h-auto drop-shadow-2xl object-contain" data-id="element-146" />
            </motion.div>
          </motion.div>

          {/* Subtitle */}
          <p className="text-sm sm:text-base md:text-lg text-text-secondary leading-relaxed max-w-xl" data-id="element-147">
            Tu sistema completo para dominar la mesa de ping pong listo:
            biomecánica, juego de pies, drills de alta densidad y estrategia.
            Construye un ataque letal y sube de nivel en 4 semanas. Sin
            estancarte.
          </p>

          {/* Format chips */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mt-1 sm:mt-2" data-id="element-148">
            <div className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-sm bg-navy-800 text-offwhite px-2 py-0.5 sm:px-3 sm:py-1 rounded border border-navy-700" data-id="element-149">
              <FileTextIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-gold-400" data-id="element-150" />{' '}
              PDF Digital
            </div>
            <div className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-sm bg-navy-800 text-offwhite px-2 py-0.5 sm:px-3 sm:py-1 rounded border border-navy-700" data-id="element-151">
              <ZapIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-gold-400" data-id="element-152" />{' '}
              Acceso Inmediato
            </div>
            <div className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-sm bg-navy-800 text-offwhite px-2 py-0.5 sm:px-3 sm:py-1 rounded border border-navy-700" data-id="element-153">
              <TargetIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-gold-400" data-id="element-154" />{' '}
              Intermedio - Avanzado
            </div>
          </div>

          {/* CTA */}
          <div className="mt-2 sm:mt-4 flex flex-col items-center gap-3 sm:gap-4 w-full" data-id="element-155">
            <div className="relative inline-block w-full sm:w-auto" data-id="element-156">
              <motion.div animate={{
              scale: [1, 1.03, 1],
              opacity: [0.4, 0.7, 0.4]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              ease: 'easeInOut'
            }} className="absolute inset-0 bg-gold-500 rounded-xl blur-md" data-id="element-157" />
              <button onClick={handleBuy} className="relative w-full sm:w-auto bg-gold-500 hover:bg-gold-400 text-offwhite font-display text-xl sm:text-2xl lg:text-3xl py-3 sm:py-4 px-6 sm:px-8 rounded-xl shadow-[0_0_20px_rgba(220,38,38,0.3)] transition-all hover:scale-[1.02] active:scale-95 uppercase tracking-wide flex items-center justify-center gap-2 sm:gap-3" data-id="element-158">
                💥 QUIERO DOMINAR LA MESA AHORA
              </button>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[10px] sm:text-xs md:text-sm text-text-secondary" data-id="element-159">
              <span className="flex items-center gap-1" data-id="element-160">
                <ShieldCheckIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-500" data-id="element-161" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-162">
                <LockIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-500" data-id="element-163" />{' '}
                Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-164">
                <CreditCardIcon className="w-3 h-3 sm:w-4 sm:h-4 text-blue-400" data-id="element-165" />{' '}
                Mercado Pago
              </span>
              <span className="flex items-center gap-1" data-id="element-166">
                <UsersIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gold-400" data-id="element-167" />{' '}
                +500 Jugadores
              </span>
              <span className="flex items-center gap-1" data-id="element-168">
                <StarIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gold-400 fill-gold-400" data-id="element-169" />{' '}
                4.9 Rating
              </span>
              <span className="flex items-center gap-1" data-id="element-170">
                <MapPinIcon className="w-3 h-3 sm:w-4 sm:h-4 text-blue-300" data-id="element-171" />{' '}
                Toda Argentina
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}